<template>
  <div>
    <TitleCard style="max-width: 97%; margin: 10px auto" title="商家入驻审核">
      <template v-slot:subTitle>
        <ul class="breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1">
          <li class="breadcrumb-item text-muted">merchantEntryReview</li>
        </ul>
      </template>
    </TitleCard>
    <div id="kt_app_main" class="app-main flex-column flex-row-fluid" v-loading="loading">
      <div class="d-flex flex-column flex-column-fluid">
        <div id="kt_app_content" class="" style="margin-bottom: 10px;padding: 0px 30px;">
          <div class="card card-flush" style="position: relative">
            <div class="card-body">
              <el-table border :data="list">
                <el-table-column
                    prop="id"
                    label="ID"
                />
                <el-table-column
                    prop="name"
                    label="联系人"
                />
                <el-table-column
                    prop="tel"
                    label="手机号"
                />
                <el-table-column
                    prop="companyName"
                    label="公司名称"
                />
                <el-table-column
                    label="营业执照">
                  <template slot-scope="scope">
                    <el-image :src="scope.row.businessLicenseUrl" alt="图片"
                              :preview-src-list="[scope.row.businessLicenseUrl]"/>
                  </template>
                </el-table-column>
                <el-table-column
                    label="食品经营许可证">
                  <template slot-scope="scope">
                    <el-image :src="scope.row.foodLicenseUrl" alt="图片"
                              :preview-src-list="[scope.row.foodLicenseUrl]"/>
                  </template>
                </el-table-column>
                <el-table-column label="状态">
                  <template slot-scope="scope">
                    <el-tag v-if="scope.row.status === 0" type="process">待审核</el-tag>
                    <el-tag v-if="scope.row.status === 1" type="success">通过</el-tag>
                    <el-tag v-if="scope.row.status === 2" type="danger">拒绝</el-tag>
                  </template>
                </el-table-column>
                <el-table-column
                    label="操作">
                  <template slot-scope="scope">
                    <div v-if="scope.row.status === 0">
                      <el-button type="primary" size="small" @click="pass(scope.row.id,1)">通过</el-button>
                      <el-button type="danger" size="small" @click="reject(scope.row.id,2)">拒绝</el-button>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="params.current"
                  :page-sizes="[10, 20, 30, 40]"
                  :page-size="params.size"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total"
                  style="display: flex;justify-content: center;margin-top: 20px">
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getCheckInListApi, passOrRejectApi} from "@/api/checkInApi";

export default {
  name: "checkIn",
  data() {
    return {
      params: {
        current: 1,
        size: 10,
      },
      total: 0,
      list: [],
      loading: false,
    }
  },
  filters: {},
  methods: {
    handleSizeChange(currentPage) {
      this.params.size = currentPage
      this.getCheckInList()
    },
    handleCurrentChange(currentPage) {
      this.params.current = currentPage
      this.getCheckInList()
    },
    async getCheckInList() {
      this.loading = true
      let {data} = await getCheckInListApi(this.params)
      this.list = data.rows
      this.total = data.total
      this.loading = false
    },
    pass(id, status) {
      this.$prompt('请输入折扣', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^(0\.([1-9]\d?|0[1-9])|0\.60?)$/,
        inputErrorMessage: '折扣填写不正确只能填写 0.01 ~ 0.6 之间的数字',
        closeOnClickModal: false
      }).then(async ({value}) => {
        await passOrRejectApi({
          id,
          status,
          discount: value
        })
        this.getCheckInList()
        this.$message.success('操作成功')
      })

      this.$message.success('操作成功')
      this.getCheckInList()
    },
    reject(id, status) {
      this.$confirm('确定要拒绝吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputType: 'text',
        inputPlaceholder: '请输入折扣'
      }).then(async () => {
        await passOrRejectApi({
          id, status,
          discount: 0
        })
        this.getCheckInList()
        this.$message.success('操作成功')
      })
    },
  },

  created() {
    this.getCheckInList()
  },
}
</script>

<style scoped>

</style>